<template>
    <div class="fill-height d-flex" style="overflow-x: hidden">

        <div class="d-flex align-center justify-center fill-height flex-grow-1" v-if="loadingPartners">
            <app-centre-loader label="Loading Sites"></app-centre-loader>
        </div>

        <template v-else>
            <v-expand-x-transition>
                <div class="px-2 fill-height of-y flex-grow-1 flex-equal" style="max-width: 35%">
                    <template v-for="partner in filteredPartners">
                        <div class="pa-2">
                            <v-card
                                    class="d-flex align-center"
                                    :key="partner._id"
                                    @click.self="selectedPartner = selectedPartner === partner ? null : partner"
                                    :raised="selectedPartner === partner"
                                    hover
                            >
                                <div class="ml-2" @click.self="selectedPartner = selectedPartner === partner ? null : partner">
                                    <template v-if="selectedPartner === partner">
                                        <v-icon color="primary">mdi-check-circle</v-icon>
                                    </template>
                                    <template v-else>
                                        <v-icon color="grey">mdi-checkbox-blank-circle-outline</v-icon>
                                    </template>
                                </div>

                                <div class="subtitle-1 font-weight-light flex-grow-1 flex-equal pa-2 text-truncate" @click.self="selectedPartner = selectedPartner === partner ? null : partner">
                                    {{partner.name}}
                                </div>


<!--                                <div v-if="user.adminSiteId !== $store.state.curSiteId" class="pr-3">-->
<!--                                    <v-tooltip top>-->
<!--                                        <template v-slot:activator="{on}">-->
<!--                                            <v-icon-->
<!--                                                    v-on="on"-->
<!--                                            >-->
<!--                                                mdi-shield-alert-->
<!--                                            </v-icon>-->
<!--                                        </template>-->
<!--                                        Limited Access-->
<!--                                    </v-tooltip>-->
<!--                                </div>-->
                            </v-card>
                        </div>
                    </template>
                </div>
            </v-expand-x-transition>

                    <v-slide-x-reverse-transition>
                        <div v-if="selectedPartner" class="fill-height" style="width: 65%">

                            <app-partner-partners-side-bar
                                    :selected-partner="selectedPartner"
                            />

<!--                            <app-partner-partner-side-bar-->
<!--                                    :selected-partner="selectedPartner"-->
<!--                                    ref="sidebar"-->
<!--                                    @partnerUpdated="selectedPartner.partner = $event"-->
<!--                            />-->
<!--                            TODO Add Here-->
<!--                            @checkSelected="checkSelectedUserTab"-->
                        </div>
                    </v-slide-x-reverse-transition>
        </template>

        <app-dlg
                v-if="showCreatePartner"
                :show-dlg.sync="showCreatePartner"
                title="Create New Partner"
                :default-padding="false"
        >

            <v-card-text class="mt-0 pt-0">
                <v-form ref="createPartnerForm" @submit="$event.preventDefault()">
                    <v-text-field
                            ref="createPartnerName"
                            v-model="createPartnerName"
                            class="pb-2 flex-grow-1"
                            flat
                            label="Partner Name"
                            hide-details="auto"
                            color="primary"
                            dark
                            :error-messages="createPartnerNameErrors"
                            :rules="[validationRules.required]"
                            @input="createPartnerNameErrors = null"
                    />

                    <v-text-field
                            ref="partnerCode"
                            v-model="createPartnerUsername"
                            class="pb-2 flex-grow-1"
                            flat
                            label="Username"
                            hide-details="auto"
                            color="primary"
                            dark
                            :error-messages="createPartnerUserErrors"
                            :rules="[validationRules.required, validationRules.email]"
                            @input="createPartnerUserErrors = null"
                    />
                </v-form>

            </v-card-text>

                            <template v-slot:actions>
                                <v-btn
                                        class="ml-2"
                                        small
                                        color="primary"
                                        @click="showCreatePartner = false"
                                        outlined
                                        size="small"
                                        :disabled="creatingPartner"
                                >
                                    Cancel
                                </v-btn>

                                <v-btn
                                        @click="createPartner"
                                        small
                                        class="ml-2"
                                        color="secondary"
                                        variant="contained"
                                        size="small"
                                        :disabled="creatingPartner"
                                        :loading="creatingPartner"
                                >
                                    Create Partner
                                </v-btn>
                            </template>
        </app-dlg>
    </div>
</template>

<script>
import AppList from "@/components/Shared/AppList/AppList";
import {mergeRecursive, nameSort} from "@/core/codeFunctions";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import AppPartnerSiteSideBar from "@/components/Partner/AppPartnerSiteSideBar";
import AppPartnerPartnersSideBar from "@/components/Partner/AppPartnerPartnersSideBar";
import {validationRules} from "@/core/codeFunctions";
import AppDlg from "@/components/Shared/AppDlg";

export default {
    components: {AppDlg, AppPartnerPartnersSideBar, AppPartnerSiteSideBar, AppCentreLoader},
    data() {
        return {
            loadingPartners: false,
            partners: null,
            selectedPartner: null,
            validationRules: validationRules,
            createPartnerUserErrors: null,
            createPartnerNameErrors: null,
            createPartnerName: null,
            createPartnerUsername: null,
            creatingPartner: false,
        }
    },
    watch: {
        showCreatePartner(val) {
            this.createPartnerUserErrors = null
            this.createPartnerNameErrors = null
            this.createPartnerName = null
            this.createPartnerUsername = null
            if (val)
                setTimeout(() => {
                    this.$refs.createPartnerName.focus();
                }, 500)
        }
    },
    created() {
    },
    beforeUnmount() {
    },
    mounted() {
        this.loadPartners();
    },
    methods: {

        async createPartner() {
            try {
                this.creatingPartner = true;
                this.createPartnerUserErrors = null
                this.createPartnerNameErrors = null

                if (!this.$refs.createPartnerForm.validate())
                    return this.$snack.error("Complete required fields")

                const {nameError, usernameError, partner} = await this.$newReq("POST", `partner/partners/create`, {
                    name: this.createPartnerName,
                    username: this.createPartnerUsername
                })

                if (nameError)
                    return this.createPartnerNameErrors = [nameError]

                if (usernameError)
                    return this.createPartnerUserErrors = [usernameError]

                if (partner)
                    this.partners.push(partner)

                console.log({partner})

                this.selectedPartner = partner

                this.showCreatePartner = false
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.creatingPartner = false
            }
        },

        async loadPartners() {
            try {
                this.loadingPartners = true;
                this.partners = await this.$newReq('GET', `partner/partners/startup`)
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
            } finally {
                this.loadingPartners = false
            }

        },
    },


    computed: {
        filteredPartners() {
            const filterStr = this.$store.state.ref.partner.partners.filterStr
            return this.partners ? (this.partners.filter((partner) => filterStr ? JSON.stringify(partner).toLowerCase().includes((filterStr || '').toLowerCase()) : true)) : []
        },
        showCreatePartner: {
            get() {
                return this.$store.state.ref.partner.partners.showCreatePartner
            },
            set(val) {
                this.$store.state.ref.partner.partners.showCreatePartner = val
            }
        },
    },
}
</script>

<style scoped>

</style>